import React from 'react';
import './AboutMe.css';

export default function AboutMe() {
  return (
    <div className="about-me">
      <h2>About Me</h2>
      <p>
        Hi! I’m Jose Martinez-Ponce, currently a grad student
        at Stevens Institute of Technology.
        Check out some cool projects and blog posts! (•‿•) Also feel free
        to browse my pictures that never got posted on socials. More to come,
        just haven't developed my other rolls yet...
      </p>
    </div>
  );
}
